export default __webpack_public_path__ + "static/media/sailor-img-1.0537cdd9.png";